<svg
    [attr.height]="height()"
    [attr.width]="width()"
    fill="none"
    style="overflow: visible"
    viewBox="0 0 44 44"
    xmlns="http://www.w3.org/2000/svg">

    <circle cx="22" cy="22" [attr.fill]="innerColor()" r="20"/>
    <circle [attr.stroke]="outerColor()" cx="22" cy="22" r="20" stroke-width="3"/>
    <mask height="40" id="mask0_583_8980" maskUnits="userSpaceOnUse" style="mask-type:alpha" width="40" x="2" y="1">
        <circle cx="22" cy="21" fill="#4CC04E" r="20"/>
    </mask>
    <g mask="url(#mask0_583_8980)">
        <path [attr.fill]="outerColor()"
            d="M22.1005 19.6658C12.0503 29.6189 12.6513 9.11509 2 19.6658L2 57.2964L42 57.2964L42 19.6658C31.3448 30.2202 32.1508 9.71259 22.1005 19.6658Z"/>
    </g>
</svg>
